import { render, staticRenderFns } from "./SettingsRow.vue?vue&type=template&id=87f1c946"
import script from "./SettingsRow.vue?vue&type=script&lang=js"
export * from "./SettingsRow.vue?vue&type=script&lang=js"
import style0 from "./SettingsRow.vue?vue&type=style&index=0&id=87f1c946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports